import Box from "@mui/material/Box";
import { styled, Theme } from "@mui/material/styles";

export const FooterBox = styled(Box)(({ theme }: { theme: Theme }) => ({
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.grey[100],
    padding: `${theme.spacing(2.5)} 0`,
    flex: 1,
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    "&>span": {
        fontSize: theme.typography.caption.fontSize,
        color: theme.palette.text.secondary,
        lineHeight: 1,
    },
    "&>p": {
        display: "inline-block",
        fontSize: theme.typography.caption.fontSize,
        color: theme.palette.text.secondary,
        margin: `0 ${theme.spacing(0.625)}`,
        padding: theme.spacing(0.75),
        lineHeight: 1,
    },
    "&>a": {
        display: "inline-block",
        fontSize: theme.typography.caption.fontSize,
        textDecoration: "none",
        color: theme.palette.text.secondary,
        margin: `0 ${theme.spacing(0)}`,
        padding: theme.spacing(0.75),
        whiteSpace: "nowrap",
        lineHeight: 1,
        "&:hover": {
            textDecoration: "underline",
        },
    },
    "@media (max-width: 1023px)": {
        flexWrap: "wrap",
    },
    "@media (max-width: 767px)": {
        flexDirection: "column",
        "&>span": {
            display: "none",
        },
    },
})) as typeof Box;
